import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  ListItemIcon,
} from "@mui/material";
import React, { useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import RepeatRoundedIcon from "@mui/icons-material/RepeatRounded";

import MultipleStopIcon from "@mui/icons-material/MultipleStop";

import Cookies from "js-cookie";
import { useSelector } from "react-redux";

const SubListItemButtom = ({ route, text }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const locFromRedux = useSelector((state) => state.common.loc);

  const ListItemButtonStyles = {
    padding: "0px 8px 0px 8px",
  };

  //   const ListItemText = ;
  return (
    <ListItemButton
      disabled={locFromRedux === ""}
      sx={ListItemButtonStyles}
      onClick={() => navigate(route)}
    >
      <ListItemText
        primary={text}
        sx={{
          color: location.pathname === route ? "#0160F1" : "black",
          margin: "4px 0px 8px 30px",
        }}
      />
    </ListItemButton>
  );
};
const Planogram_List = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const loc = Cookies.get("ssp_loc") || "";
  const location = useLocation();

  const ListItemButtonStyles = {
    padding: "0px 8px 0px 8px",
  };
  const ListItemBody = {
    padding: "0px 0px 0px 0px",
    margin: "0px 0px 0px 0px",
  };
  const ListItemMain = {
    padding: "32px 0px 0px 0px",
    margin: "0px 0px 0px 0px",
  };
  return (
    <List sx={ListItemMain}>
      <ListItem sx={ListItemBody}>
        <ListItemButton
          sx={ListItemButtonStyles}
          onClick={() => setOpen(open === true ? false : true)}
        >
          <RepeatRoundedIcon sx={{ fontSize: 20, marginRight: "8px" }} />

          <ListItemText
            primary="Planogram"
            onClick={() => {
              //   navigate(`/inventory_billing`);
            }}
          />
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setOpen(!open);
            }}
          >
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </ListItemButton>
      </ListItem>
      <Collapse in={true} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {loc.length !== 4 ? (
            <SubListItemButtom
              route={"/plano_portal/gallery"}
              text={"Gallery"}
            />
          ) : (
            <SubListItemButtom
              route={`/plano_portal/store`}
              text={"Dashboard"}
            />
          )}
          <SubListItemButtom
            route={"/plano_portal/plano"}
            text={"Shelf Blueprint"}
          />
        </List>
      </Collapse>
    </List>
  );
};

export default Planogram_List;
